import { Box, ModBox, Spacer } from "@jfs/ui-new";
import { useNavigation } from "@react-navigation/native";
import { useCallback, useState } from "react";
import { Container } from "../../components/Container";
import { NewTable } from "../../components/NewTable";
import { SearchFilter } from "../../components/SearchFilter";
import { useLazyApiData, useStores } from "../../data/store";

const AssignedDevicesList = () => {

    const {
        assignedDevicesList,
        getAssignedDevicesToMidAsync
    } = useStores((store) => ({
        assignedDevicesList: store.onboarding.assignedDevicesList,
        getAssignedDevicesToMidAsync: store.onboarding.getAssignedDevicesToMidAsync

    }))

    const navigation = useNavigation()

    const [selectedMid, setSelectedMid] = useState('');

    const [getAssignedDevicesListAsync, assignedDevicesListHandler] = useLazyApiData(getAssignedDevicesToMidAsync)

    const handleOnChange = useCallback((text) => { console.log(text) }, [])
    const handleMidSearch = useCallback(({ search }) => {
        console.log(search)
        setSelectedMid(search)
        search && getAssignedDevicesListAsync(search)
    }, [])

    return <Box flex={1}>
        <SearchFilter
            onChange={handleOnChange}
            onSearch={(data: any) => handleMidSearch(data)}
            placeholder={'Search By MID'}
        />
        <Container
            isLoading={assignedDevicesListHandler.state === 'pending'}
            errorMessage={assignedDevicesListHandler?.data?.message}
            onRetry={() => getAssignedDevicesListAsync(selectedMid)}
        >
            <Spacer size={20} />

            <ModBox flex={1} show={assignedDevicesList?.length > 0}>
                <NewTable
                    data={assignedDevicesList}
                    rowHeight={48}
                    headerHeight={84}
                    headerRowKeys={headerTitles}
                    // onRowEditClicked={onItemChecked}
                    freezeColumn={'selected'}
                    onAction={(_, id) => {
                        //setShowConfirmAlert(true)
                        // setClickedId(id)
                    }}
                    onRowClick={(data) => {
                        alert(JSON.stringify(data))
                        navigation.navigate("DeviceInvoicesList", { id: data.id })
                    }} />

            </ModBox>


        </Container>
    </Box>
}

export default AssignedDevicesList;


const headerTitles = {
    id: "Id",
    mid: "Mid",
    tid: "Tid",
    deviceid: "Device Id",
    vpa: "vpa",
    deviceType: "Device Type",
    status: "STATUS",
    createdAt: "Created At",
    updatedAt: "Updated At",
    oneTimeSetUpFee: "One Time Fee",
    monthlyCharges: "Monthly Charges"
}